export default "__VITE_ASSET__BIBou5vt__"